import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatOrderCreatedDate = (dateString) => {
  //dayjs(dateString).format("MMM D, hh:mm A");
  //checks for valida js dates
  if (isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("MMM D, hh:mm A");
};

export const formatYYYY_MM_DD = (dateString) => {
  //checks for valida js dates
  if (isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("YYYY-MM-DD");
};

export const formatYYYY_MM_DD_HH_MM_A = (dateString) => {
  //checks for valida js dates
  if (isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("YYYY-MM-DD hh:mm A");
};

export const formatHH_MM_SS = (dateString) => {
  //checks for valida js dates
  if (isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("hh:mm A");
};

export const formatPaymentDate = (dateString) => {
  //checks for valida js dates
  if (isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("MMMM D, YYYY, h:mm A");
};

export const formatChatDate = (dateString) => {
  if (!dateString) return "-";

  // Parse the input date and convert to local timezone
  const messageDate = dayjs.utc(dateString).tz(dayjs.tz.guess());
  const now = dayjs();

  // Start of today and yesterday (local time)
  const startOfToday = now.startOf("day");
  const startOfYesterday = now.subtract(1, "day").startOf("day");

  // Check if the date falls within today or yesterday
  if (messageDate.isAfter(startOfToday)) return "Today";
  if (messageDate.isAfter(startOfYesterday)) return "Yesterday";

  // For all other dates, return formatted date
  return messageDate.format("MMMM DD, YYYY");
};


export const formatIndicatorDate = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("YYYY/MM/DD hh:mm A");
};

export const formatHoursToDays = (hours) => {
  if (!Number.isFinite(hours)) {
    return "N/A";
  } else if( hours <= 0 ){
    return "0 hour";
  }

  const days = Math.floor(hours / 24);
  const remainingHours = Math.round(hours % 24); 

  return [
    days ? `${days} day${days !== 1 ? "s" : ""}` : "",
    remainingHours ? `${remainingHours} hour${remainingHours !== 1 ? "s" : ""}` : "",
  ].filter(Boolean).join(" ");
};

export const formatJoinedDate = (dateString) => {
  if (!dateString) return "N/A";
  
  try {
    const dateObj = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) return "N/A";
    
    const datePart = dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    
    const timePart = dateObj.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    
    return `${datePart} - ${timePart}`;
  } catch (error) {
    return "N/A";
  }
};

export const formatDateForInput = (dateString) => {
  console.log("formatDateForInput", dateString);
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  return date.toISOString().split('T')[0];
};


export const formatDateForBackend = (dateString) => {
  console.log("formatDateForBackend", dateString);
  if (!dateString) return null;
  return new Date(dateString);
};


export const localDateAsUtcMidnight = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  
  const utcDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
  return utcDate.toISOString();
}